import React, { memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ReadMoreButton } from '@yme/molecules/buttons';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel2 } from '@yme/tokens/typography';
import { buildKey, getIsExternalLink, isPDFlink, onOpenWindow } from '@yme/utils/common';
import { AspectRatio, BLANK } from '@yme/utils/constants';
import { ContentStyled, ForOwnersWrapper, ImageWrapperStyled } from './styled';
const dataTestIdCard = 'card';
function ForOwnersCardComponent(props) {
    const { cardProps, isRightToLeft, marginBottom = 'auto' } = props;
    const { image, title, description, link, labelLink, countLineVisible = 3, isEllipsisEndingLine = true, aspectRatio = AspectRatio.RectangleLevel6, } = cardProps;
    const history = useHistory();
    const isExternal = link && getIsExternalLink(link);
    const onClickHandler = useCallback(() => {
        if (isPDFlink(link)) {
            onOpenWindow(isExternal ? link : `${window.location.origin}${link}`, BLANK);
            return;
        }
        if (link && isExternal) {
            onOpenWindow(link, BLANK);
        }
        if (link && !isExternal) {
            history.push(link);
        }
    }, [link, isExternal, history]);
    const dataTestIdLinkInternal = buildKey(dataTestIdCard, 'link-internal');
    const dataTestIdLinkExternal = buildKey(dataTestIdCard, 'link-external');
    const dataTestIdLink = isExternal ? dataTestIdLinkInternal : dataTestIdLinkExternal;
    return (React.createElement(ForOwnersWrapper, { marginBottom: marginBottom },
        React.createElement(FlexWrapper, { mb: "16px", mbTablet: "16px" },
            React.createElement(ImageWrapperStyled, { ...image, alt: title, onClick: onClickHandler, dataTestId: dataTestIdCard, aspectRatio: aspectRatio })),
        React.createElement(FlexWrapper, { mb: "8px", mbTablet: "8px" },
            React.createElement(RegularTextLevel2, { weight: 500, title: title, isEllipsisEndingLine: isEllipsisEndingLine }, title)),
        React.createElement(FlexWrapper, { mb: "8px", mbTablet: "8px" },
            React.createElement(ContentStyled, { color: colorCoreBlack300, countLineVisible: countLineVisible }, description)),
        React.createElement(FlexWrapper, null,
            React.createElement(ReadMoreButton, { isRightToLeft: isRightToLeft, onClickHandler: onClickHandler, labelLink: labelLink, dataTestId: dataTestIdLink }))));
}
export const ForOwnersCard = memo(ForOwnersCardComponent);
ForOwnersCard.displayName = 'ForOwnersCard_Molecule';
